import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './researchers.stub.css';

interface ResearchersStubProps {
    itemsCount: number;
}

const class_ = b.with('researchers-stub');

const ResearchersStub: StatelessComponent<ResearchersStubProps> = ({ itemsCount }) => {
    const items = Array(itemsCount).fill(0);

    return (
        <div className={class_()}>
            {items.map((_: any, index: number) => (
                <div key={index} className={class_('item')}>
                    <Rect width={108} height={108} className={class_('image')} />
                    <Rect height={24}  className={class_('name')} />
                </div>
            ))}
        </div>
    );
};

export default ResearchersStub;
